import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse, createParamString } from 'data_sources/constants';
import { PerformanceReportingMetricsResponse } from '../_types';
import { generateMetrics } from './performanceReportingDataGenerator';
import { useRiskPoolPerformanceReportingDemo } from '../../../../_data_sources/useRiskPoolPerformanceReportingDemo';

interface UseMetricsParams {
  orgId: string;
  childOrgId: string;
  assignedModule: string;
  startDate: string;
  endDate: string;
}

export default function useMetrics(
  params: UseMetricsParams,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const useDemoData = useRiskPoolPerformanceReportingDemo();

  return useQuery<PerformanceReportingMetricsResponse, Error>(
    [
      'risk_pool_perf_report_metrics',
      params.orgId,
      params.childOrgId,
      params.assignedModule,
      params.startDate,
      params.endDate,
    ],
    async (): Promise<PerformanceReportingMetricsResponse> => {
      try {
        if (useDemoData) {
          const demoData = generateMetrics(params.childOrgId, params.assignedModule, params.startDate, params.endDate);
          console.log('[useMetrics] Demo Data Response:', JSON.stringify(demoData, null, 2));
          return demoData;
        }

        const queryParams = createParamString({
          assignedModule: params.assignedModule,
          startDate: params.startDate,
          endDate: params.endDate,
        });
        const url = `${baseApiUrl()}/organizations/${params.orgId}/risk-pool/related-organizations/${params.childOrgId}/performance-reporting/metrics?${queryParams}`;
        const data: PerformanceReportingMetricsResponse = await fetcher({
          method: 'get',
          url,
        });
        console.log('[useMetrics] API Response:', JSON.stringify(data, null, 2));
        return data;
      } catch (err) {
        if (onError) onError(err as ServerErrorResponse);
        throw err;
      }
    },
    {
      ...options,
      enabled:
        !!params.orgId && !!params.childOrgId && !!params.assignedModule && !!params.startDate && !!params.endDate,
    }
  );
}
